module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "demo grid center middle row sm-hide md-hide",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.nextExample()
      }
    }
  }, [_c('transition', [_c('pre', {
    key: _vm.example,
    staticClass: "language-javascript cell grid column"
  }, [_c('code', {
    staticClass: "cell grow",
    domProps: {
      "innerHTML": _vm._s(_vm.examples[_vm.example])
    }
  })])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "get-started"
  }, [_c('router-link', {
    staticClass: "btn primary",
    attrs: {
      "to": "/guide/getting-started"
    }
  }, [_vm._v("Get Started")]), _vm._v(" "), _vm._m(2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo grid column middle center"
  }, [_c('h1', {
    staticClass: "cell"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/jpex.svg")
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "cell"
  }, [_vm._v("Easy Dependency Injection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary"
  }, [_c('ul', {
    staticClass: "grid sm-wrap"
  }, [_c('li', {
    staticClass: "cell"
  }, [_c('h3', [_vm._v("Dependency Injection")]), _vm._v(" "), _c('div', [_vm._v("\n          Easily register dependencies and inject them throughout your application. Just point and shoot - Jpex handles resolving, caching, and injecting all of your dependencies.\n        ")])]), _vm._v(" "), _c('li', {
    staticClass: "cell"
  }, [_c('h3', [_vm._v("Class or Container pattern")]), _vm._v(" "), _c('div', [_vm._v("\n          Jpex can be used as a class generator, supporting deep inheritence and class configuration options, or as a stateless dependency injection container.\n        ")])]), _vm._v(" "), _c('li', {
    staticClass: "cell"
  }, [_c('h3', [_vm._v("Extensible")]), _vm._v(" "), _c('div', [_vm._v("\n          Highly configurable, node & web capable, with an extensive plugin system and a straightfoward API; Jpex can be used and moulded however you want.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn primary",
    attrs: {
      "href": "https://github.com/jpex-js/jpex",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "btn-icon",
    attrs: {
      "src": require("../assets/github-light.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Source Code")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7117f0b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 61
// module chunks = 0